import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Page Not Found</title>
      </Helmet>
      <div className="flex items-center justify-center h-screen">
        404 Page Not Found
        <button
          className="bg-blue-500 text-white p-2 rounded-md"
          onClick={() => navigate("/")}
        >
          Go to Home
        </button>
      </div>
    </>
  );
};

export default PageNotFound;
